import React, { Component } from "react";
import { connect } from "react-redux";
import { Table, Input } from "antd";
import { getSSPAcademicYear } from "../../utils/dateUtil";
import { usrRole } from "../../utils/dataUtil";
import { API_BASE } from "../../utils/contrains";
import {
  req_list_ssp_all_in_one_principal,
  req_downloadfile_ssp_all_in_one_principal,
} from "../../api";
class PrincipalAllInOneList extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    planAcademicYear: getSSPAcademicYear(new Date()),
    searchField: "NONE",
    searchValue: "",
    loading: false,
    userLevel: "NORMAL",
    data: [],
  };

  componentWillMount() {
    this.api_rows_list();
  }

  /////////////////////
  api_rows_list = async () => {
    const { planAcademicYear, searchField, searchValue } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });
    const result = await req_list_ssp_all_in_one_principal(
      userCode,
      userLevel,
      planAcademicYear,
      searchField,
      searchValue,
      token
    );
    if (result.total > 0) {
      const items = result.data;
      this.setState({ data: items });
    } else {
      this.setState({ data: [] });
    }
  };

  api_file_download = async () => {
    const { planAcademicYear, searchField, searchValue } = this.state;
    const { token, role, userCode } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    // download file data
    const fileUrl = await req_downloadfile_ssp_all_in_one_principal(
      userCode,
      userLevel,
      planAcademicYear,
      searchField,
      searchValue,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  /////////////////////
  handle_data_refresh = () => {
    this.api_rows_list();
    //console.log("refresh");
  };

  handle_show_ui_modal = (modal, item) => {
    // console.log("handle_show_ui_modal");
    switch (modal) {
      case "download":
        this.api_file_download();
        //console.log("download");
        break;
      default:
    }
  };

  handleSelectChange = (event) => {
    const value = event.target.value;
    this.setState({
      searchField: value,
    });
  };
  /////////////////////
  render() {
    const { data, loading, planAcademicYear, searchField, searchValue } =
      this.state;
    const columns = [
      {
        title: "生源學校",
        width: 320,
        children: [
          {
            title: "地區",
            dataIndex: "CountyCityName",
            align: "center",
            width: 60,
            render(text, record) {
              return {
                props: {
                  style: { fontWeight: 900 },
                },
                children: <div>{text}</div>,
              };
            },
          },
          {
            title: "學校",
            dataIndex: "HighSchoolTwName",
            align: "center",
            width: 120,
            render(text, record) {
              return {
                props: {
                  style: { fontWeight: 900 },
                },
                children: <div>{text}</div>,
              };
            },
          },
          {
            title: "總召",
            dataIndex: "TwName",
            align: "center",
            width: 60,
            render(text, record) {
              return {
                props: {
                  style: { fontWeight: 900 },
                },
                children: <div>{text}</div>,
              };
            },
          },
          {
            title: "出席",
            dataIndex: "DeanBeenGo",
            align: "center",
            width: 40,
            render(text, record) {
              var textColor = "#006400";
              return {
                props: {
                  style: { fontWeight: 900 },
                  color: textColor,
                },
                children: <div>{text === "Y" ? "是" : ""}</div>,
              };
            },
          },
          {
            title: "規劃人數",
            dataIndex: "TotalNumberOfPeople",
            align: "center",
            width: 40,
            render(text, record) {
              return {
                props: {
                  style: { fontWeight: 900 },
                },
                children: <div>{text}</div>,
              };
            },
          },
        ],
      },
      {
        title: "生管學院",
        width: 60,
        responsive: ["lg"],
        children: [
          {
            title: "服設",
            width: 10,
            children: [
              {
                title: "專責",
                align: "center",
                dataIndex: "PrincipalTwNamesL3",
                key: "PrincipalTwNamesL3",
                render(text, record) {
                  var textColor = "#c3d953";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: textColor,
                      },
                    },
                    children: <div>{text}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "美容",
            width: 10,
            children: [
              {
                title: "專責",
                align: "center",
                dataIndex: "PrincipalTwNamesL4",
                key: "PrincipalTwNamesL4",
                render(text, record) {
                  var textColor = "#c3d953";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: textColor,
                      },
                    },
                    children: <div>{text}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "幼保",
            width: 10,
            children: [
              {
                title: "專責",
                align: "center",
                dataIndex: "PrincipalTwNamesL5",
                key: "PrincipalTwNamesL5",
                render(text, record) {
                  var textColor = "#c3d953";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: textColor,
                      },
                    },
                    children: <div>{text}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "餐飲",
            width: 10,
            children: [
              {
                title: "專責",
                align: "center",
                dataIndex: "PrincipalTwNamesL165",
                key: "PrincipalTwNamesL165",
                render(text, record) {
                  var textColor = "#c3d953";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: textColor,
                      },
                    },
                    children: <div>{text}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "生服",
            width: 10,
            children: [
              {
                title: "專責",
                align: "center",
                dataIndex: "PrincipalTwNamesL178",
                key: "PrincipalTwNamesL178",
                render(text, record) {
                  var textColor = "#c3d953";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: textColor,
                      },
                    },
                    children: <div>{text}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "運休",
            width: 10,
            children: [
              {
                title: "專責",
                align: "center",
                dataIndex: "PrincipalTwNamesL199",
                key: "PrincipalTwNamesL199",
                render(text, record) {
                  var textColor = "#c3d953";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: textColor,
                      },
                    },
                    children: <div>{text}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "國企",
            width: 10,
            children: [
              {
                title: "專責",
                align: "center",
                dataIndex: "PrincipalTwNamesM7",
                key: "PrincipalTwNamesM7",
                render(text, record) {
                  var textColor = "#5b98db";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: textColor,
                      },
                    },
                    children: <div>{text}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "財金",
            width: 10,
            children: [
              {
                title: "專責",
                align: "center",
                dataIndex: "PrincipalTwNamesM8",
                key: "PrincipalTwNamesM8",
                render(text, record) {
                  var textColor = "#5b98db";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: textColor,
                      },
                    },
                    children: <div>{text}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "資管",
            width: 10,
            children: [
              {
                title: "專責",
                align: "center",
                dataIndex: "PrincipalTwNamesM24",
                key: "PrincipalTwNamesM24",
                render(text, record) {
                  var textColor = "#5b98db";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: textColor,
                      },
                    },
                    children: <div>{text}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "企管",
            width: 10,
            children: [
              {
                title: "專責",
                align: "center",
                dataIndex: "PrincipalTwNamesM161",
                key: "PrincipalTwNamesM161",
                render(text, record) {
                  var textColor = "#5b98db";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: textColor,
                      },
                    },
                    children: <div>{text}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "應英",
            width: 10,
            children: [
              {
                title: "專責",
                align: "center",
                dataIndex: "PrincipalTwNamesT187",
                key: "PrincipalTwNamesT187",
                render(text, record) {
                  var textColor = "#A4C5C3";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: textColor,
                      },
                    },
                    children: <div>{text}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "旅館",
            width: 10,
            children: [
              {
                title: "專責",
                align: "center",
                dataIndex: "PrincipalTwNamesT196",
                key: "PrincipalTwNamesT196",
                render(text, record) {
                  var textColor = "#A4C5C3";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: textColor,
                      },
                    },
                    children: <div>{text}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "養生",
            width: 10,
            children: [
              {
                title: "專責",
                align: "center",
                dataIndex: "PrincipalTwNamesT214",
                key: "PrincipalTwNamesT214",
                render(text, record) {
                  var textColor = "#A4C5C3";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: textColor,
                      },
                    },
                    children: <div>{text}</div>,
                  };
                },
              },
            ],
          },
        ],
      },
      {
        title: "設計學院",
        width: 60,
        responsive: ["lg"],
        children: [
          {
            title: "室設",
            width: 10,
            children: [
              {
                title: "專責",
                align: "center",
                dataIndex: "PrincipalTwNamesD11",
                key: "PrincipalTwNamesD11",
                render(text, record) {
                  var textColor = "#f5b06e";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: textColor,
                      },
                    },
                    children: <div>{text}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "視傳",
            width: 10,
            children: [
              {
                title: "專責",
                align: "center",
                dataIndex: "PrincipalTwNamesD17",
                key: "PrincipalTwNamesD17",
                render(text, record) {
                  var textColor = "#f5b06e";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: textColor,
                      },
                    },
                    children: <div>{text}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "商設",
            width: 10,
            children: [
              {
                title: "專責",
                align: "center",
                dataIndex: "PrincipalTwNamesD18",
                key: "PrincipalTwNamesD18",
                render(text, record) {
                  var textColor = "#f5b06e";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: textColor,
                      },
                    },
                    children: <div>{text}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "多動",
            width: 10,
            children: [
              {
                title: "專責",
                align: "center",
                dataIndex: "PrincipalTwNamesD164",
                key: "PrincipalTwNamesD164",
                render(text, record) {
                  var textColor = "#f5b06e";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: textColor,
                      },
                    },
                    children: <div>{text}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "時尚",
            width: 10,
            children: [
              {
                title: "專責",
                align: "center",
                dataIndex: "PrincipalTwNamesD159",
                key: "PrincipalTwNamesD159",
                render(text, record) {
                  var textColor = "#f5b06e";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: textColor,
                      },
                    },
                    children: <div>{text}</div>,
                  };
                },
              },
            ],
          },

        ],
      },
      {
        title: "藝術學院",
        width: 40,
        responsive: ["lg"],
        children: [
          {
            title: "漫畫",
            width: 10,
            children: [
              {
                title: "專責",
                align: "center",
                dataIndex: "PrincipalTwNamesT212",
                key: "PrincipalTwNamesT212",
                render(text, record) {
                  var textColor = "#f5b06e";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: textColor,
                      },
                    },
                    children: <div>{text}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "美術",
            width: 10,
            children: [
              {
                title: "專責",
                align: "center",
                dataIndex: "PrincipalTwNamesA19",
                key: "PrincipalTwNamesA19",
                render(text, record) {
                  var textColor = "#dc4f9c";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: textColor,
                      },
                    },
                    children: <div>{text}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "音樂",
            width: 10,
            children: [
              {
                title: "專責",
                align: "center",
                dataIndex: "PrincipalTwNamesA20",
                key: "PrincipalTwNamesA20",
                render(text, record) {
                  var textColor = "#dc4f9c";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: textColor,
                      },
                    },
                    children: <div>{text}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "舞蹈",
            width: 10,
            children: [
              {
                title: "專責",
                align: "center",
                dataIndex: "D03DoneCityTotal",
                key: "D03DoneCityTotal",
                render(text, record) {
                  var textColor = "#dc4f9c";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: textColor,
                      },
                    },
                    children: <div>{text}</div>,
                  };
                },
              },
            ],
          },
          {
            title: "行樂",
            width: 10,
            children: [
              {
                title: "專責",
                align: "center",
                dataIndex: "PrincipalTwNamesA213",
                key: "PrincipalTwNamesA213",
                render(text, record) {
                  var textColor = "#dc4f9c";
                  return {
                    props: {
                      style: {
                        fontWeight: 900,
                        color: textColor,
                      },
                    },
                    children: <div>{text}</div>,
                  };
                },
              },
            ],
          },
        ],
      },
    ];

    return (
      <>
        <Input
          placeholder="規劃年度"
          style={{
            width: 55,
            height: 39,
            margin: "0 5px",
            color: "red",
          }}
          onChange={(event) =>
            this.setState({ planAcademicYear: event.target.value })
          }
          value={planAcademicYear}
          readOnly={true}
          disabled={true}
        />
        <select
          className="form-control"
          style={{ width: "180px", display: "inline-block" }}
          onChange={this.handleSelectChange}
          value={searchField}
        >
          <option key={"NONE"} value="NONE">
            其他條件
          </option>
          <option key={"HighSchoolTwName"} value="HighSchoolTwName">
            生源學校校名
          </option>
          <option key={"TwName"} value="TwName">
            總召姓名
          </option>
          <option key={"CountyCityName"} value="CountyCityName">
            生源學校地區
          </option>
        </select>
        <Input
          placeholder="關鍵字"
          style={{
            width: 80,
            height: 39,
            margin: "0 5px",
            backgroundColor: "LightYellow",
          }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <button
          className="btn btn-info"
          onClick={this.handle_data_refresh}
          style={{
            marginLeft: "2px",
            marginBottom: "4px",
            display: "inline-block",
          }}
        >
          <i className="fas fa-sync-alt"></i>
        </button>
        <button
          className="btn btn-info"
          onClick={() => this.handle_show_ui_modal("download", {})}
          style={{ marginLeft: "2px", marginBottom: "4px" }}
        >
          <i className="fas fa-cloud-download-alt"></i>
        </button>
        <Table
          bordered
          columns={columns}
          dataSource={data}
          pagination={false}
          loading={loading}
        />
        <p></p>
      </>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(PrincipalAllInOneList);
